import styled from 'styled-components';
import { themes } from '../../assets';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: #fff;
`;

export const PowerPlug = styled.div`
  width: 100vw;
  margin: clamp(40px, 12vw, 110px) 0 clamp(40px, 10vw, 100px);

  img {
    width: 100vw;
  }
`;

export const MaintenanceText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  color: ${themes.darkblue};

  padding: 0 16px;
  box-sizing: border-box;

  h1 {
    /* fluido: 32px (phone) -> 70px (desktop) */
    font-size: clamp(32px, 8vw, 70px);
    font-style: normal;
    font-weight: 900;
    line-height: 1.15;
    letter-spacing: 0em;
    text-align: center;
  }

  p {
    /* fluido: 18px (phone) -> 40px (desktop) */
    font-size: clamp(18px, 4.5vw, 40px);
    font-style: normal;
    font-weight: 500;
    line-height: 1.3;
    letter-spacing: 0em;
    text-align: center;
  }
`;

export const Logo = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100vw;
  z-index: 10px;
  
  img {
    width: min(307px, 70vw);
    height: auto;
    margin-bottom: 50px;
    z-index: 10;
  }
`;

export const Footer = styled.img`
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100vw;
`;
